import { teacherServiceURL } from '../endpoint';

export const schoolSearchURL = ({ terms }: { terms: string }) => {
  const url = new URL(`schools/search`, teacherServiceURL);

  url.searchParams.append('terms', terms);
  return url;
};
